import { TimeGate } from "./TimeGate.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  TimeGate
};
//# sourceMappingURL=index.js.map
